// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#4193cf","subMenuActiveText":"#4193cf","menuBg":"#fff","menuHover":"#f1f1f1","subMenuBg":"#eee","subMenuHover":"#e1e1e1","sideBarWidth":"220px"};